/** @format */

import {capitalize} from 'frontier/ds/quoter/functions/format';
import React from 'react';

/*fix the format since we receive
a single string from the BE
*/
export const prettyInternetInputMethod = name => {
    let prettified = name.split('_');
    prettified = `${prettified[1]}
    ${prettified[0]}`;

    return prettified;
};

/********************************************************
 * prettyAddress formats a billing or a shipping address
 * in a way it can be displayed under a dropdown. The
 * function return an obj with three properties: an
 * array with the formatted address, the default
 * address formatted if it exists or a default
 * string if a default address does not exist.
 * It takes three arguments: (array of
 * addresses to work with, 0 or 1 [0
 * to return billing addresses only
 * or 1 to return shipping address]
 * and finally a click event for
 * the `editAddress` button)
 * ************************
 */
export const IS_SHIPPING_ADDRESS = true;

export const prettyAddress = (addresses, type, handleEdit, handleDelete) => {
    const addressType = type === IS_SHIPPING_ADDRESS ? 'shipping' : 'billing';

    let defaultAddressLabel = `Click to select or add a ${addressType} address`;
    let defaultAddress;

    let prettyAddresses = [];

    /* removing this option for now. Might delete in the future once
        we know it is not needed 03/29/23 🐺
    */
    // if (type !== IS_SHIPPING_ADDRESS) {
    //     prettyAddresses.push({
    //         value: 'cta',
    //         label: `+ Add a New ${addressType} Address`,
    //         className: 'color-action-primary'
    //     });
    // }

    const getAddresses = (address, i) => {
        let shouldPush =
            (address.is_shipping_address === IS_SHIPPING_ADDRESS && type === IS_SHIPPING_ADDRESS) ||
            (address.is_shipping_address === !IS_SHIPPING_ADDRESS && type === !IS_SHIPPING_ADDRESS);

        const companyLabel = address?.company ? `(${address?.company}),` : '';

        const addressLabel = `${address?.address1} ${address?.address2}, ${address?.city}, ${address?.state} ${address?.zip}`;
        const fullLabel = `${companyLabel} ${addressLabel}`;

        // remove unnecessary spaces
        addressLabel
            ?.replace(/(\r\n|\n|\r)/gm, '')
            .replace(/\s+/g, ' ')
            .trim();

        // we might want to include the company in the future. For now leave it here
        // const labelWithoutCompany = `
        // ${capitalize(address?.first_name)} ${capitalize(address?.last_name)}
        // (${capitalize(address?.company)}), ${capitalize(address?.address1)}
        // ${address?.address2 ? capitalize(address?.address2) : ''},
        // ${capitalize(address?.city)}, ${address?.state}
        // ${address?.zip}`;

        if (address.is_default_address && shouldPush) {
            defaultAddressLabel = fullLabel;
            defaultAddress = address;
        }

        const value = address.id;

        const icons = [
            {
                color: '#26313A',
                name: 'edit',
                handleClick: handleEdit
            }
        ];

        if (!address.is_default_address) {
            icons.push({
                handleClick: handleDelete,
                color: '#df3d33',
                name: 'trash'
            });
        }

        const addressToAdd = {
            rightLabel: address.is_default_address ? {label: 'Default'} : null,
            icons,
            label: (
                <div className="d-flex align-items-center justify-content-start flex-wrap pe-3">
                    <b className="me-3">{companyLabel}</b>
                    <span>{addressLabel}</span>
                    {address.is_blind && <span className="ms-2 font-weight-bold">[[BLIND]]</span>}
                </div>
            ),
            filterValue: fullLabel,
            sort: address.company?.toLowerCase(), // not used other than to sort them
            value
        };

        if (fullLabel && address && shouldPush && address.value !== 'cta') {
            if (address.is_default_address) prettyAddresses.splice(1, 0, addressToAdd);
            else prettyAddresses.push(addressToAdd);
        }
    };

    addresses.map(getAddresses);

    function sortAlphabetically(arrayToFilter) {
        arrayToFilter.sort((a, b) => {
            if (a.sort < b.sort) {
                return -1;
            }
            if (a.sort > b.sort) {
                return 1;
            }
            return 0;
        });
        return arrayToFilter;
    }

    return {addresses: sortAlphabetically(prettyAddresses), defaultAddressLabel, defaultAddress};
};

/*******************************************************
 * Takes in an address entity and returns a formatted
 * address that is user-friendly. Similar to the
 * function above but it only returns a single
 * label and accepts a single address entity.
 * Accepts two arguments of type string:
 * 'shipping' or 'billing'
 * ***********************
 * */
export const singlePrettyAddress = (address, type = 'shipping') => {
    let defaultAddressLabel = `Click to select or add a ${type} address`;
    if (!address) return defaultAddressLabel;

    const companyName = address?.company ? `(${address?.company}),` : '';
    const label = `
        ${companyName}
        ${address?.address1}
        ${address?.address2}, ${address?.city}, ${address?.state}
        ${address?.zip}`;

    // we might want to include the company in the future. For now leave it here
    const labelWithoutCompany = `
        ${capitalize(address?.first_name)} ${capitalize(address?.last_name)}
        (${capitalize(address?.company)}), ${capitalize(address?.address1)}
        ${address?.address2 ? capitalize(address?.address2) : ''},
        ${capitalize(address?.city)}, ${address?.state}
        ${address?.zip}`;

    return label
        ?.replace(/(\r\n|\n|\r)/gm, '')
        .replace(/\s+/g, ' ')
        .trim();
};

/*******************************************************
 * Takes in a string containing a user's full name and
 * splits it into first_name and last_name. Only the
 * first part of the string is used as first name
 * and everything else is treated as last name.
 * For example: Pastor Jonathan Edwards will
 * return {first_name: 'pastor', last_name:
 * 'Jonathan Edwards'}
 * *****************
 * */
export const formatFullNameString = full_name => {
    let first_name = '';
    let last_name = '';

    if (full_name?.split(' ').length >= 2) {
        full_name
            ?.trim()
            .split(' ')
            .map((w, i) => {
                if (i === 0) first_name = w.trim();
                if (i > 0) last_name = last_name.trim() + ' ' + w;
            });
    } else if (full_name?.split(' ').length === 1) {
        first_name = full_name;
    }

    return {first_name, last_name};
};

/***********************************************
This function loops through the payment_profiles
and formats them in a way they can
be presented under a dropdown
*****************************/
export const formatUserProfiles = paymentProfiles => {
    if (!paymentProfiles) return {profiles: [], initialValue: '', defaultProfile: {}};

    const profiles = [
        {
            value: 'cta',
            label: '+ Add a New Debit/ Credit Card',
            className: 'color-action-primary'
        }
    ];

    let initialValue = 'Select a stored credit / debit card or add a new one';
    let defaultProfile;

    paymentProfiles.map(prof => {
        let formatProf = prof.label.split(' (');
        formatProf = formatProf && formatProf[0].toUpperCase() + ` ****${formatProf[1]}`;
        // let icons = [{name: 'delete', color: 'red', handleClick: () => {}}];
        formatProf = formatProf.replace(')', '');
        const value = prof.id;
        let rightLabel;
        let label;
        let className;

        if (!prof.is_expired) {
            label = `${formatProf} Expires (${prof.expires_formatted})`;
            // icons.unshift({name: 'edit', color: 'black', handleClick: () => {}});
        } else {
            rightLabel = {label: `Expired`};
            label = `${formatProf} Expired (${prof.expires_formatted})`;
            className = 'color-alert-negative';
        }

        if (prof.is_default) {
            defaultProfile = prof;
            initialValue = label;
        }

        const profile = {
            rightLabel,
            //icons,
            value,
            label,
            className
        };

        prof.is_default ? profiles.unshift(profile) : profiles.push(profile);
    });

    return {profiles, initialValue, defaultProfile};
};

/******************************************************
 returns a-ready-to-display in dropdown profile_payment
 in the format: METHOD ****1234 Expires (Month, Year)
 For example VISA ****4112 Expires (Feb, 2024)
 *********************************************
 */
export const formatSingleUserProfiles = profile => {
    if (!profile) return '';

    let formatProf = profile.label.split(' (');
    formatProf = formatProf && formatProf[0].toUpperCase() + ` ****${formatProf[1]}`;

    formatProf = formatProf.replace(')', '');

    let label;

    if (!profile.is_expired) {
        label = `${formatProf} Expires (${profile.expires_formatted})`;
    } else {
        label = `${formatProf} Expired (${profile.expires_formatted})`;
    }

    return label;
};

/******************************************************
 Pass the label that we receive from UPS and thi func
 will return a label that we can render on
 a dropdown It also formats the pricing
 by removing the decimals
 ************************
 */
export const prettyShippingMethod = (label, total = 0) => {
    if (!label) return '';

    let originalLabel = label.split(' - ');

    if (originalLabel.length >= 2) {
        let removePrice = originalLabel[1].split(' (');
        label = originalLabel[0];

        if (removePrice.length >= 2) {
            label = `${label} - ${removePrice[1]
                .replace('in', '')
                .replace('day', 'Day')
                .replace('tra', 'Tra')
                .replace('office', 'office in')}`;

            label = label.replaceAll(')', '').replaceAll('(', '');

            return label;
        }
    }

    return '';
};

/*************************************************************
 Formats an array of shipping methods into a dropdown-friendly
 array of objects.
 *****************
 */
export const prettyShippingMethods = (methods, useCustomerAccount, customerAccount) => {
    return methods.map(function (option) {
        const label = prettyShippingMethod(option?.label);

        return {
            use_customer_account_number: option.use_customer_account_number,
            shipping_method_name: option.shipping_method_name,
            shipping_method_code: option.shipping_method_code,
            shipping_provider: option.shipping_provider,
            value: [
                this,
                option.shipping_method_name,
                useCustomerAccount ? 0 : option.shipping_amt,
                [option.shipping_provider, option.shipping_method_code]
            ],
            rightLabel: {
                label: useCustomerAccount
                    ? `Account #${customerAccount}`
                    : option?.shipping_amt === '0.00'
                    ? 'Free'
                    : `$${option?.shipping_amt}`
            },
            label
        };
    });
};

/*************************************************************
Accepts a string of emails separated by comma and validates/
 encodes it into a value that can be safely saved in the
 Database.
 *********
 */
export const parseEmailLIst = emails => {
    let list = emails && emails.split(',');

    // is there more than one email?
    if (list && list.length > 1) {
        let parsed = [];

        list.map(email => {
            if (email) parsed.push(email.trim().replaceAll(',', ''));
        });

        return parsed.join(', ');
    } else {
        return emails;
    }
};
